import { render, staticRenderFns } from "./Arrivals.vue?vue&type=template&id=e5010c0c"
import script from "./arrivals.js?vue&type=script&lang=js&external"
export * from "./arrivals.js?vue&type=script&lang=js&external"
import style0 from "./arrivals.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports